/**
 * 描述：租户管理--基本信息设置
 * 日期：2017-10-18
 * 作者：liu_jinming
 */
'use strict';
angular.module('smsVerificationModule', ['tManageMentServiceModule'])
    .controller('smsVerificationCtrl', ['$scope', 'localStorageService', 'item', 'trsHttpService', '$modalInstance', '$timeout', '$interval', '$validation', 'modalDialog', '$sessionStorage', function($scope, localStorageService, item, trsHttpService, $modalInstance, $timeout, $interval, $validation, modalDialog, $sessionStorage) {
        initStatus();
        initData();

        /** [initData description: 初始化数据] */
        function initStatus() {
            $scope.data = {
                // userInfo: localStorageService.get('mlfCachedUser'), // session改变
                userInfo: $sessionStorage.get('mlfCachedUser'),
                phoneNum: '',
                countDown: 60,
                buttonInfo: '获取验证码',
                modalTitle: '', // item.num === '1'?"修改IP地址":"解绑IP地址"
                changeMethod: item.num,
                VerificationCode: '',
                tenantIP: item.item.tenantIP === '还未配置IP地址，请先下载工具包并按工具包中的要求完成操作' ? '' : item.item.tenantIP,
                addIP: ''
            };
            if (item.num === '1') {
                $scope.data.modalTitle = '修改IP地址';
            } else if (item.num === '2') {
                $scope.data.modalTitle = '解绑IP地址';
            } else if (item.num === '3') {
                $scope.data.modalTitle = '新增IP地址';
            }
            $scope.status = {
                isFishedSMS: false,
                isDisabled: false,
            };
        }

        /** [initStaus description: 初始化状态] */
        function initData() {
            requestData();
        }

        /** [requestData description: 请求租户管理员的手机号码] */
        function requestData() {
            var params = {
                'serviceid': 'mlf_tenantuploadmanage',
                'methodName': 'queryUserMobile'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.phoneNum = data.replace(/\"/g, '');
            });
        }

        /** [getSMSInfo description:点击获取短信] */
        $scope.getSMSInfo = function() {
            var params = {
                serviceid: 'mlf_tenantuploadmanage',
                methodName: 'sendSMScode',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.TYPE == '3') {
                    countDown();
                }
            });
        };

        /** [saveIP description:保存修改的IP] */
        $scope.saveIP = function() {
            $validation.validate($scope.smsVerification).success(function() {
                var reg = /[^\u0000-\u00FF]/;
                if (reg.test($scope.data.tenantIP)) {
                    modalDialog.alertType('', '禁止含有中文字符，请用英文逗号分隔!', 'error', false);
                    return;
                }
                var params = {
                    'serviceid': 'mlf_tenantuploadmanage',
                    'methodName': 'updateTenantIp',
                    'TENANTNAME': item.item.TENANTNAME,
                    'IP': $scope.data.tenantIP
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.TYPE == '3') {
                        modalDialog.alertType('', '修改成功!', 'success', false);
                        $modalInstance.close();
                    } else {
                        modalDialog.alertType('', '修改失败!', 'error', false);
                    }
                });
            }).error(function() {
                modalDialog.alertType('', '请检查IP格式!', 'error', false);
            });
        };

        /** [addIP description： 新增IP的设置] */
        $scope.addIP = function() {
            $validation.validate($scope.smsVerification).success(function() {
                var reg = /[^\u0000-\u00FF]/;
                if (reg.test($scope.data.tenantIP)) {
                    modalDialog.alertType('', '禁止含有中文字符，请用英文逗号分隔!', 'error', false);
                    return;
                }
                var params = {
                    'serviceid': 'mlf_tenantuploadmanage',
                    'methodName': 'addTenantIp',
                    'TENANTNAME': item.item.TENANTNAME,
                    'IP': $scope.data.addIP
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.TYPE == '3') {
                        modalDialog.alertType('', '新增成功!', 'success', false);
                        $modalInstance.close();
                    } else {
                        modalDialog.alertType('', '新增失败!', 'error', false);
                    }
                });
            }).error(function() {
                modalDialog.alertType('', '请检查IP格式!', 'error', false);
            });
        };

        function countDown() {
            if ($scope.data.countDown == 60) {
                if ($scope.data.countDown > 0) {
                    $scope.data.isDisabled = true;
                    $scope.data.buttonInfo = $scope.data.countDown + '(S)';
                    $scope.data.countDown = $scope.data.countDown - 1;
                } else {
                    $scope.data.isDisabled = false;
                    $scope.data.buttonInfo = '获取验证码';
                    $scope.data.countDown = 60;
                    $interval.cancel(timer);
                }
            }
            var timer = $interval(function() {
                if ($scope.data.countDown > 0) {
                    $scope.data.isDisabled = true;
                    $scope.data.buttonInfo = $scope.data.countDown + '(S)';
                    $scope.data.countDown = $scope.data.countDown - 1;
                } else {
                    $scope.data.isDisabled = false;
                    $scope.data.buttonInfo = '获取验证码';
                    $scope.data.countDown = 59;
                    $interval.cancel(timer);
                }
            }, 1000);
            $scope.$on('$destroy', function() {$interval.cancel(timer);});
        }

        /** [checkSMS description:验证验证码] */
        $scope.checkSMS = function() {
            $validation.validate($scope.smsVerification).success(function() {
                var params = {
                    'serviceid': 'mlf_tenantuploadmanage',
                    'methodName': 'checkSMSCode',
                    'SMSCODE': $scope.data.VerificationCode
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.TYPE === '3') {
                        $scope.data.isFishedSMS = true;
                    } else {
                        modalDialog.alertType('', '请确认验证码!', 'warning', false);
                    }
                });
            }).error(function() {
                modalDialog.alertType('', '请检查验证码格式!', 'warning', false);
            });
        };

        /** [deleteIP description: 点击确定接触IP绑定] */
        $scope.deleteIP = function() {
            var params = {
                'serviceid': 'mlf_tenantuploadmanage',
                'methodName': 'delTenantInfo',
                'TENANTNAME': item.item.TENANTNAME
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.TYPE == '3') {
                    modalDialog.alertType('', '解绑成功!', 'success', false);
                    $modalInstance.close();
                } else {
                    modalDialog.alertType('', '解绑失败!', 'error', false);
                }
            });
        };
        // 点击关闭
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);
